<template>
  <div class="business_work">
    <div class="back-img">
      <div class="title-nav">
        <el-row :gutter="20">
          <el-col
            :class="{ active: index === isActive }"
            :key="index"
            :span="2"
            @click.native="handleClick(index)"
            v-for="(item, index) in navData"
            >{{ item.value }}</el-col
          >
        </el-row>
      </div>
    </div>
    <div class="business_msg">
      <template v-if="isShow == 2">
        <div class="partner">
          <img alt="合作银行" class="bank_title" src="@image/bank_title.png" />
          <div class="bank_img">
            <a href="http://bank.pingan.com/" target="_blank">
              <img alt src="@image/pabank.png" />
            </a>
            <!-- <img src="@image/cnbank.png" alt="" /> -->
          </div>
          <div class="partner-group">
            <div
              :class="{ active_tab: index === isTab }"
              :key="index"
              @click="handleTab(index, item.id)"
              class="name_top"
              v-for="(item, index) in bankData"
            >
              <div class="name">{{ item.value }}</div>
            </div>
          </div>
          <template v-if="isTab == 0">
            <!-- <div class="item-box item-img"> -->
            <!-- <div v-for="(dataVal, index) in factory.company" :key="index">
                {{ dataVal.name }}
            </div>-->
            <div class="iconImg">
              <a
                :href="dataVal.url"
                :key="index"
                target="_blank"
                v-for="(dataVal, index) in factory.companyImg"
              >
                <template v-if="dataVal.url == 'http://www.dfztruck.com/'">
                  <img :src="dataVal.img" alt style="max-height: 65%;" />
                </template>
                <template v-else-if="dataVal.url == 'https://www.xmjl.com/'">
                  <img :src="dataVal.img" alt style="max-height: 85%;" />
                </template>

                <template
                  v-else-if="
                    dataVal.url ==
                      'http://www.sinoarr.com/helps/xiangjianzhonggong.html'
                  "
                >
                  <img :src="dataVal.img" alt style="max-height: 90%;" />
                </template>
                <template v-else-if="dataVal.url == 'http://www.jiuhezg.com/'">
                  <img :src="dataVal.img" alt style="max-height: 100%;" />
                </template>
                <template
                  v-else-if="dataVal.url == 'https://jinanzhongnuo.com/'"
                >
                  <img :src="dataVal.img" alt style="max-height: 90%;" />
                </template>
                <template v-else-if="dataVal.url == 'http://www.hnslzg.com/'">
                  <img :src="dataVal.img" alt style="max-height: 90%;" />
                </template>
                <template v-else-if="dataVal.url == 'http://www.mtsweep.com/'">
                  <img :src="dataVal.img" alt style="max-height: 100%;" />
                </template>
                <template v-else-if="dataVal.url == 'http://www.cshammer.net/'">
                  <img :src="dataVal.img" alt style="max-height: 100%;" />
                </template>
                <template
                  v-else-if="dataVal.url == 'http://www.jiubangzhonggong.com/'"
                >
                  <img :src="dataVal.img" alt style="max-height: 75%;" />
                </template>
                <template
                  v-else-if="dataVal.url == 'https://www.xcmg.com/schwing/'"
                >
                  <img :src="dataVal.img" alt style="max-height: 35%" />
                </template>

                <template v-else>
                  <img :src="dataVal.img" alt />
                </template>
              </a>
            </div>
            <!-- </div> -->
          </template>
          <template v-else>
            <div class="item-box">
              <div
                :key="index"
                class="box"
                v-for="(vip_data, index) in saleData.slice(
                  (pagination.current - 1) * pagination.pageSize,
                  (pagination.current - 1) * pagination.pageSize +
                    pagination.pageSize
                )"
              >
                {{ vip_data }}
              </div>
            </div>
            <el-pagination
              :current-page="pagination.current"
              :page-size="pagination.pageSize"
              :total="pagination.total"
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
            ></el-pagination>
          </template>
          <!-- <template v-if="isTab == 2">
            <div class="item-box">
              <div
                v-for="(data_name, index) in saleData"
                :key="index"
                class="box"
              >
                {{ data_name }}
              </div>
            </div>
          </template>-->
        </div>
      </template>
      <template v-if="isShow == 1">
        <div class="business_city">
          <div class="mb-30">
            <el-button
              :class="{ btn_none: btnAll }"
              @click="handleBtn(true)"
              class="el-primary-border all-btn"
              type="primary"
              >全部</el-button
            >
          </div>
          <el-button
            :class="{ active_btn: item.id === isBtn }"
            :key="index"
            @click="handleBtn(item.id, item.name)"
            class="el-btn"
            type="primary"
            v-for="(item, index) in city"
            >{{ item.name }}</el-button
          >

          <div class="city-box">
            <div :key="index" v-for="(item, index) in cityData">
              <template v-if="item.children">
                <div
                  :key="index"
                  class="city-item"
                  v-for="(child, index) in item.children"
                >
                  <img :src="child.img" alt class="cityImg" />
                  <div class="right-box">
                    <h2>{{ child.companyName }}</h2>
                    <div>
                      <p>{{ child.address }}</p>
                      <span>咨询电话：</span>
                      <span>{{ child.tel }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="city-item">
                  <img :src="item.img" alt class="cityImg" />
                  <div class="right-box">
                    <h2>{{ item.companyName }}</h2>
                    <div>
                      <p>{{ item.address }}</p>
                      <span>咨询电话：</span>
                      <span>{{ item.tel }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-if="isShow == 0">
        <div class="about-msg" v-for="(it, i) in starData" :key="i">
          <img alt class="img-qy" :src="it.img" style="width:750px" />
          <div class="content">
            <h2>{{ it.title }}</h2>
            <div class="line mt-30"></div>
            <div class="first" v-html="it.content"></div>
          </div>
        </div>
        <!-- <div class="about-msg">
          <img alt class="img-qy" src="@image/business2.png" />
          <div class="content">
            <h2>大客户架构</h2>
            <div class="line mt-30"></div>
            <p class="first">
              通过大客户架构，使经销商与品农的合作更加紧密，双方互惠共赢；经销商可享受到品农更加优惠的政策和更优质的服务，提高在当地的市场占有率，进一步做大做强；品农也会有稳定的客户并提高在市场的竞争力和影响力。
            </p>
          </div>
        </div> -->
        <!-- <div class="about-msg">
          <img src="@image/business3.png" alt class="img-qy" />
          <div class="content">
            <h2>行业资源</h2>
            <div class="line mt-30"></div>
            <p class="first">
              公司5位高管有着二十多年金融、商用车、科技行业从业及管理经验，积累了丰富的金融行业资源，深谙商用车后市场的节点流程及市场痛点，善用科技手段解决商用车金融服务问题。
            </p>
            <p>
              品农作为平安银行、中国银行的资产管理合作方，借助科学技术深度链接商用车金融产业链，整合产业链优势资源，赋能厂商与经销商，践行普惠金融造福终端客户。
            </p>
          </div>
        </div>-->
      </template>
    </div>
  </div>
</template>

<script>
import dataList from './company.js'
import { getAdvantage } from '@/api/home'
import { getSale, getBusiness } from '@/api/sale'
export default {
  data() {
    return {
      navData: [
        { id: 1, value: '企业优势' },
        { id: 2, value: '业务范围' },
        { id: 3, value: '合作伙伴' }
      ],
      bankData: [
        { id: 1, value: '合作厂家' },
        { id: 2, value: '大客户架构主经销商' },
        { id: 3, value: '经销商' }
      ],
      isActive: 0,
      isShow: 0,
      isTab: 0,
      isBtn: '',
      btnAll: false,
      searchCity: '',
      cityData: [],
      city: [],
      factory: dataList.data,
      saleType: '',
      saleData: [],
      pagination: {
        total: 0,
        pageSize: 50,
        current: 1
      },
      starData: []
    }
  },
  watch: {
    //搜索
    searchCity(val) {
      if (val) {
        this.city.filter(item => {
          if (item.name === val) {
            this.cityData = [item]
            this.isBtn = item.id
            this.btnAll = true
          }
        })
      } else {
        this.cityData = this.city
      }
    },
    $route: function(val) {
      this.routerName(val.query.routerPath)
    }
  },
  // 监听路由
  mounted() {
    let name = this.$route.query.routerPath
    this.routerName(name)
  },
  created() {
    // this.city = dataList.data.city
    // this.cityData = dataList.data.city
    this.searchCity = this.$route.query.cityName
    this.getStar()
    this.getCity()
  },
  methods: {
    // 业务范围
    getCity() {
      getBusiness()
        .then(res => {
          let data = res.data
          this.city = data
          this.cityData = data
          if (this.searchCity) {
            this.city.filter(item => {
              if (item.name === this.searchCity) {
                this.cityData = [item]
                this.isBtn = item.id
                this.btnAll = true
              }
            })
          } else {
            this.cityData = this.city
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 企业优势
    getStar() {
      getAdvantage()
        .then(res => {
          let data = res.data
          this.starData = data
        })
        .catch(err => {
          console.log(err)
        })
    },
    //大客户经销商和私人订制经销商
    init() {
      const data = { type: this.saleType }
      getSale(data)
        .then(res => {
          let data = res.data
          this.saleData = data
          this.pagination.total = data.length
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getSale ', data).then(res => {
      //   if (res.data.code) {
      //     let data = res.data

      //     this.saleData = data.data
      //     this.pagination.total = data.data.length
      //   }
      // })
    },
    //分页
    handleCurrentChange(val) {
      this.pagination.current = val
    },
    //主菜单
    handleClick(index) {
      this.isActive = index
      this.isShow = index
      // this.searchCity = ''
      // this.isBtn = ''
      // if (index == 1) {
      //   this.getCity()
      // }
    },
    //切换合作伙伴
    handleTab(index, id) {
      this.isTab = index
      this.pagination.current = 1
      if (id === 2) {
        this.saleType = 1
        this.init()
      } else if (id === 3) {
        this.saleType = 2
        this.init()
      }
    },
    //业务范围
    handleBtn(id, name) {
      this.searchCity = name
      if (typeof id === 'boolean') {
        this.btnAll = false
        this.isBtn = ''
      } else {
        this.isBtn = id
        this.btnAll = true
      }
    },
    routerName(name) {
      switch (name) {
        case 'qyys':
          this.isShow = 0
          this.isActive = 0
          break
        case 'city':
          this.isShow = 1
          this.isActive = 1
          break
        case 'hzhb':
          this.isShow = 2
          this.isActive = 2
          break
      }
    }
  }
}
</script>

<style lang="scss" scope>
.business_work {
  .back-img {
    background-image: url('../../assets/image/business_work.png');
    margin-top: -62px;

    position: relative;
    .title-nav {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 85%;
      margin: auto;
      height: 65px;
      line-height: 65px;
      font-size: 16px;
      .el-row {
        background: #013165;
        .el-col {
          margin-left: 30px;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          text-align: center;
        }
        .active {
          color: rgba(255, 255, 255, 1);
          background: rgba(13, 126, 248, 1);
          color: #fff;
        }
      }
    }
  }
  .business_msg {
    text-align: start;
    text-align: initial;
    position: relative;
    .about-msg {
      width: 85%;
      margin: 100px auto;
      display: flex;
      img {
        width: 860px;
        height: 500px;
        // width: 600px;
        object-fit: cover;
      }
      .content {
        text-align: initial;
        height: 350px;
        background: rgba(247, 249, 255, 1);
        padding: 25px 50px;
        z-index: 99;
        margin-left: -246px;
        margin-top: 60px;
        width: 100%;
        h2 {
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 25px;
        }
        .line {
          width: 19px;
          height: 5px;
          background: rgba(13, 126, 248, 1);
        }
        p {
          // text-indent: 35px;
          line-height: 40px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
        }
        .first {
          margin-top: 30px;
          /deep/p {
            line-height: 40px !important;
            font-size: 16px !important;
            font-weight: 400 !important;
            color: rgba(85, 85, 85, 1) !important;
            span {
              line-height: 40px !important;
              font-size: 16px !important;
              font-weight: 400 !important;
              color: rgba(85, 85, 85, 1) !important;
            }
          }
        }
      }
    }
  }
  .business_city {
    width: 85%;
    margin: 30px auto;
    h2 {
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
    }
    .el-btn {
      margin: 15px 10px 15px 0px;
      background: #fff;
      color: #62697b;
      border-radius: 0;
      border-color: rgba(227, 231, 237, 1);
    }
    .all-btn {
      color: #fff;
      border-radius: 0;
      background: #0590ff !important;
    }
    .btn_none {
      background: #fff !important;
      color: #62697b !important;
      border-color: rgba(227, 231, 237, 1);
    }
    .active_btn {
      color: #fff;
      background: #0590ff !important;
    }
    .city-box {
      background: #f1f4f8;
      padding: 30px 50px;
      color: #333;
      .city-item {
        display: flex;
        margin-bottom: 40px;
        overflow: hidden;
        .cityImg {
          width: 300px;
          height: 235px;
          -webkit-transition: all 0.5s;
          transition: all 0.5s;
        }
        // img {

        // }
        .right-box {
          line-height: 34px;
          padding: 40px 40px 25px 40px;
          width: 100%;
          background: #fff;
          div {
            margin-top: 70px;
          }
        }
      }

      .city-item:hover img {
        -webkit-transform: scale(1.18);
        transform: scale(1.18);
        -webkit-transform-origin: center;
        transform-origin: center;
      }
    }
  }
  .partner {
    width: 85%;
    margin: 30px auto;
    .bank_title {
      margin: 30px auto;
      display: block;
    }
    .bank_img {
      text-align: center;
      img {
        width: 405px;
      }
    }
    .partner-group {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      cursor: pointer;
      .name_top {
        padding: 25px 0;
        font-size: 24px;
        font-weight: 400;
        color: rgba(40, 48, 59, 1);
      }
      .name {
        border-right: 1px solid #d8d8d8;
        padding: 0 25px;
      }
    }
    // .item-img {
    //   justify-content: center;
    // }
    .item-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .box {
        margin-right: 30px;
        // flex-basis: 40%;
        flex-basis: 31%;
        height: 46px;
        line-height: 46px;
        // width: 600px;
        // height: 71px;
        // line-height: 71px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(186, 186, 186, 1);
        font-size: 18px;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        text-align: center;
        margin-top: 30px;
      }
    }
    .iconImg {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 50px;
      a {
        width: 370px;
        height: 80px;
        // display: table-cell;
        vertical-align: middle;
        text-align: center;
        line-height: 80px;
      }
      img {
        max-height: 55%;
        // min-width: 75%;
        object-fit: contain;
        vertical-align: middle;
      }
    }
    .active_tab {
      color: #0d7ef8 !important;
      border-bottom: 2px solid #0d7ef8;
    }
    .el-pagination {
      margin-top: 30px;
      text-align: center;
    }
  }
}
</style>
